import {Datoformatering} from 'felles/tjenester/Datoformatering';

export function relativDatoKortformatFilterForInjisering() {
        return [Datoformatering.regNavn, relativDatoKortformatFilter];
    }

    export function relativDatoKortformatFilter(datoformatering:Datoformatering):Function {
        return function (dato) {
            if (typeof dato === 'undefined' || dato === null) return '';
            return datoformatering.somFraNåUtenKlokkeslett(dato);
        };
    }
